/**
 * Test IDs for QA automation.
 */
export const testIds = {
  tripOrderEditModalCancel: "trip-order-edit-modal-cancel",
  tripOrderEditModalSave: "trip-order-edit-modal-save",
} as const;
